import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Shop from "examples/Icons/Shop";
import BusinessProfile from "layouts/businessList";
import Ratingandreviews from "layouts/ratingandreviews";
import Offers from "layouts/offers";
import { Business, Dns, Shop2Outlined, ShopOutlined } from "@mui/icons-material";
import StarIcon from '@mui/icons-material/Star';
import RedeemIcon from '@mui/icons-material/Redeem';
import BusinessDetail from "layouts/businessDetail"
import OfferDetail from "layouts/offerDetail"
import ForgetPassword from "layouts/authentication/forgot" ;

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Dns size="12px" />,
    component: <Dashboard />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Business Profile",
    key: "business-Profile",
    route: "/business-Profile",
    icon: <Business size="12px" />,
    component: <BusinessProfile />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Ratings & Reviews",
    key: "Ratings-&-Reviews",
    route: "/Ratings-&-Reviews",
    icon: <StarIcon size="12px" />,
    component: <Ratingandreviews />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Offers",
    key: "offers",
    route: "/offers",
    icon: <RedeemIcon  size="12px" />,
    component: <Offers />,
    noCollapse: true,
  },
  {
    route: "/profile",
    key: "profile",
    component: <Profile />,
  },
  {
    route: "/forgot-password",
    component: <ForgetPassword />,
  },
  {
    route: "/offerDetail/:id",
    component: <OfferDetail />,
  },
  {
    route: "/business/detail/:id",
    component: <BusinessDetail />,
  },
  {
    route: "/login",
    component: <SignIn />,
  },
  {
    route: "/register",
    component: <SignUp />,
  },
];

export default routes;














